import { trans } from '@spotahome/soyuz/client';

import ContactUsIllustration from '@spotahome/landings-common/src/components/ContactUsIllustration';

import ContactUs from './ContactUs';

import './Hero.scss';

const Hero = () => {
  return (
    <div className="hero">
      <div className="hero__wrapper">
        <div className="hero__form">
          <div className="hero__header">
            <h1 className="hero__header-title">
              {trans('contact-us.header.title')}
            </h1>
            <p className="hero__header-subtitle">
              {trans('contact-us.header.subtitle')}
            </p>
          </div>
          <ContactUs />
        </div>
        <ContactUsIllustration className="hero__image" />
      </div>
    </div>
  );
};

export default Hero;
